import ContentsBase from './ContentsBase';
import { formatUTCDate, parseUTCDate } from "../../../utils/FPEUtils";
// import LegendHimawariCldTop from "../legend/LegendHimawariCldTop";
import { WX_ID_HIMAWARI } from "../../../store/WeatherContentsState";
import TimeController from "../../map/helper/TimeController";

class HimawariCldTop extends ContentsBase {
  static NAME = WX_ID_HIMAWARI;
  static TIME_RANGE = 5 * 60 * 60 * 1000;
  prevValidtime;
  setRevision;
  constructor(setRevision) {
    super('Himawari', 'SAT_CLD', 'WNI_ANLSIS_SAT_WORLD_CLDTOP');
    this.setRevision = setRevision;
    this.timeController = new TimeController(`CS_${WX_ID_HIMAWARI}`, {
      crossSection: true,
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg).then(() => {
          if (this.timeController._parent !== null && autoFlg) {
            this.setRevision();
          }
        });
      }
    });
  }

  parseTimelist() {
    const validtime = this.dataReference.query("validtime").value();
    this.validtimeList = this.filterValid(validtime, HimawariCldTop.TIME_RANGE);
    if(this.prevValidtime) {
      if(this.isDiffPrevDataValid()) {
        this.setRevision();
      }
    }
    this.prevValidtime = [...this.validtimeList];
  }

  getOpt(validtime) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForValid(validtime);
        return {
          SAT_CLD: {
            Validtime: this.shownTime,
            Visible: this.isVisible()
          }
        };
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }

    });
  }

  // getLegend() {
  //   return {
  //     id: HimawariCldTop.NAME,
  //     label: 'Himawari',
  //     component: LegendHimawariCldTop,
  //     contents: this
  //   }
  // }

  getTimeInformation() {
    return {
      id: HimawariCldTop.NAME,
      label: 'Himawari',
      baseTime: this.shownTime ? formatUTCDate(parseUTCDate(this.shownTime), '%Y/%m/%d %H:%MZ') : "---"
    }
  }

  getTimeControllerInfo() {
    return {
      mapContentsId: WX_ID_HIMAWARI,
      timeController: this.timeController
    };
  }
}

export default HimawariCldTop;